if (!customElements.get('cart-recommended-product')) {
  class CartRecommendedProduct extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        form: 'form',
        cartItems: 'cart-items',
        miniCartItems: 'cart-drawer-items',
        image: '[data-image]',
        variantSelect: 'select[name="id"]',
      }
    }

    /**
     * Attach events.
     * @returns {Void}
     */
    attachEvents = () => {
      this.querySelector(this.selectors.form)?.addEventListener('submit', (event) => this.handleSubmit(event));
      this.addEventListener('change', (event) => this.handleVariantChange(event));
    }

    /**
     * Handles form submit event.
     *
     * @param {Event} event
     * @returns {Void}
     */
    handleSubmit = (event) => {
      event.preventDefault();
      this.addToCart();
    }

    /**
     * Handles variant change.
     *
     * @param {Event} event
     * @returns {Void}
     */
    handleVariantChange = (event) => {
      // Change image
      const selectedIndex = event.target.selectedIndex;
      this.hideAllImages();
      this.showImage(selectedIndex);
    }

    /**
     * Shows image based on index. If index doesn't exists - shows first image.
     *
     * @param {Number} index
     * @returns {Void}
     */
    showImage = (index) => {
      const images = this.querySelectorAll(this.selectors.image);

      if (!images[index]) {
        return images[0]?.removeAttribute('hidden');
      }
      images[index]?.removeAttribute('hidden');
    }

    /**
     * Hides all images.
     * @returns {Void}
     */
    hideAllImages = () => {
      this.querySelectorAll(this.selectors.image).forEach((image) => image.setAttribute('hidden', true));
    }

    /**
     * Add the current product to the cart and update it.
     * @returns {Promise<Response>}
     */
    addToCart = () => {
      const cartItems =
        document.querySelector(this.selectors.miniCartItems) ||
        document.querySelector(this.selectors.cartItems);

      const formData = new FormData(this.querySelector(this.selectors.form));
      const body = JSON.stringify({
        id: formData.get('id'),
        quantity: formData.get('quantity'),
        sections: cartItems.getSectionsToRender().map(
          section => section.section
        ),
        sections_url: window.location.pathname
      });

      return fetch(`${routes.cart_add_url}`, {
        ...fetchConfig(),
        ...{ body }
      })
        .then(response => response.text())
        .then(state => {
          const parsedState = JSON.parse(state);

          cartItems.getSectionsToRender().forEach(section => {
            const elementToReplace = document.querySelector(section.id);

            elementToReplace.innerHTML = this.#getSectionInnerHTML(
              parsedState.sections?.[section.section],
              section?.selector
            );
          });
        });
    }

    /**
     * Parse a string and get a specific node.
     *
     * @param {String} html - string with the markup
     * @param {String} selector - element selector
     * @returns {Node} - the selected node
     */
    #getSectionInnerHTML = (html, selector) => {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    connectedCallback() {
      this.attachEvents();

      // Show selected variant image.
      const selectedIndex = this.querySelector(this.selectors.variantSelect)?.selectedIndex;
      if (selectedIndex !== 'undefined') {
        this.hideAllImages();
        this.showImage(selectedIndex);
      }
    }
  }
  customElements.define('cart-recommended-product', CartRecommendedProduct);
}
